module.exports = __webpack_public_path__ + "media/svg/next-5530dc6f.svg";